import React from 'react'
import T, { useT } from '../../i18n/T'
import SVGIcon from '../../svg/SVGIcon'
import s from './HdTooltip.less'

const HdTooltip = ({ onClick }) => (
  <div className={s.root} onClick={onClick}>
    <div className={s.closeButton}>
      <SVGIcon icon={'croix-android'} />
    </div>
    <p className={s.title}>
      <T id={'map.tools.layers.highdef.benefits.title'} />
    </p>
    <p
      className={s.content}
      dangerouslySetInnerHTML={{
        __html: useT('map.tools.layers.highdef.benefits.list')
      }}
    />
  </div>
)

export default HdTooltip
